import Vue from 'vue'

const mixins = Vue.mixin({
    data: () => ({
        analyses: {
            types: {
                apps: 'Apps',
                anonymized: 'Anonymized',
                cohorts: 'Cohorts',
                competitors: 'Competitors',
                poi: 'POI',
            },
            additional: {
                audience: 'Audience',
                cross_visitation: 'Cross',
                frequency: 'Frequency',
                distance: 'Distance'
            }
        },
        minimum_audience_to_activate: 500
    }),
    methods: {
        toggleItems(dataset, data) {
            if (this.selectedAllItems(dataset, data)) {
                let modified_data = this.transformSnakeToUpperCase(data)
                this.$store.commit('CreateAudienceStore/SET_DATASET_' + modified_data, {
                    dataset: dataset,
                    value: []
                })
            } else {
                if (data === 'locations') {
                    this.$store.commit('CreateAudienceStore/SET_DATASET_LOCATIONS', {
                        dataset: dataset,
                        value: this.$store.getters['CreateAudienceStore/getLocationsAllIds'](dataset)
                    })
                } else {
                    let items = this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'All'](dataset).map(a => {
                        return a.value
                    })

                    this.$store.commit('CreateAudienceStore/SET_DATASET_' + this.transformSnakeToUpperCase(data), {
                        dataset: dataset,
                        value: items
                    })
                }
            }
            let function_name = this.transformFullSnakeToCamelCase(data + "_changed")
            if (typeof this[function_name] === "function") {
                this[function_name]()
            }
        },
        searchItems(dataset, data) {
            if (!this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'SearchInput'](dataset)) {
                this.$store.commit('CreateAudienceStore/SET_DATASET_' + this.transformSnakeToUpperCase(data) + '_ALL', {
                    dataset: dataset,
                    value: this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'Copy'](dataset)
                })
            }
            let all_data = this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'Copy'](dataset).filter((item) => {
                if (data === 'countries') {
                    return item.text.toLowerCase().indexOf(this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'SearchInput'](dataset).toLowerCase()) > -1 ||
                        item.value.toLowerCase().indexOf(this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'SearchInput'](dataset).toLowerCase()) > -1
                } else {
                    return item.text.toLowerCase().indexOf(this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'SearchInput'](dataset).toLowerCase()) > -1
                }
            })

            this.$store.commit('CreateAudienceStore/SET_DATASET_' + this.transformSnakeToUpperCase(data) + '_ALL', {
                dataset: dataset,
                value: all_data
            })
        },
        zipCodeValidation(v) {
            if (v.length > 0) {
                const tmp = v.split("\n")
                let fail = ''
                let status = true
                tmp.forEach(function (item, index) {
                    if (!/^[a-zA-Z0-9 ]*$/.test(item)) {
                        fail = index + 1
                        status = false
                    } else {
                        return true
                    }
                })

                return (status) ? true : 'Zipcode ' + fail + ' is invalid'

            } else {
                return true
            }
        },
        isUSASelected(countries) {
            return countries.indexOf('USA', countries) !== -1
        },
        toggleShow(name, index) {
            let label = name + '_' + index

            if (this.showedData.includes(label)) {
                let indexRemoval = this.showedData.indexOf(label)
                this.showedData.splice(indexRemoval, 1)
            } else {
                this.showedData.push(label)
            }
        },
        transformSnakeToUpperCase(string) {
            const string_array = string.split('_')
            const modified_array = []

            string_array.forEach((item) => {
                let modified_string = item.toUpperCase()

                modified_array.push(modified_string)
            })

            return modified_array.join("_")
        },
        transformSnakeToCamelCase(string) {
            const string_array = string.split('_')
            const modified_array = []

            string_array.forEach((item) => {
                let modified_string = item.replace(item[0], item[0].toUpperCase())

                modified_array.push(modified_string)
            })

            return modified_array.join("")
        },
        transformFullSnakeToCamelCase(string) {
            const string_array = string.split('_')
            const modified_array = []

            string_array.forEach((item, index) => {
                let modified_string

                if (index === 0) {
                    modified_string = item.toLowerCase()
                } else {
                    modified_string = item.replace(item[0], item[0].toUpperCase())
                }

                modified_array.push(modified_string)
            })

            return modified_array.join("")
        }
    },
    computed: {
        selectedAllItems() {
            return (dataset, data) => {
                return this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'Selected'](dataset).length === this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'All'](dataset).length
            }
        },
        selectedSomeItems() {
            return (dataset, data) => {
                return this.$store.getters['CreateAudienceStore/get' + this.transformSnakeToCamelCase(data) + 'Selected'](dataset).length > 0 && !this.selectedAllItems(dataset, data)
            }
        },
        showingIcon() {
            return (dataset, data) => {
                if (this.selectedAllItems(dataset, data)) return 'mdi-close-box'
                if (this.selectedSomeItems(dataset, data)) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            }
        },
    }
})

export default mixins